import {useEffect, useState} from 'react';
import {IEvent} from '../@interfaces/services/Events';
import useWebSocket, {getChannelName, getSubscriber} from '@src/hooks/useWebSocket';

type Params<Message = unknown> = Parameters<typeof useWebSocket<Message>>[0];
type Result<Message = unknown> = ReturnType<typeof useWebSocket<Message>>;

type ListResult<Message = unknown> = {
    lastMessages: Result<Message>['lastMessage'][],
    lastEventsNames: Result<Message>['lastEventName'][],
    lastEventsFiredAt: Result<Message>['lastEventFiredAt'][],
    lastEventFiredAt: Result<Message>['lastEventFiredAt'],
};

const push = <T>(list: T[], index: number, value: T): T[] => {
    const newList = [...list];
    newList[index] = value;

    return newList;
};

export default function useWebSocketForList<Message = any>(params: Params<Message>[] | null): ListResult<Message> {
    const [lastMessages, setLastMessages] = useState<ListResult<Message>['lastMessages']>([]);
    const [lastEventsNames, setLastEventsNames] = useState<ListResult<Message>['lastEventsNames']>([]);
    const [lastEventsFiredAt, setLastEventsFiredAt] = useState<ListResult<Message>['lastEventsFiredAt']>([]);
    const [lastEventFiredAt, setLastEventFiredAt] = useState<Result<Message>['lastEventFiredAt']>(null);

    useEffect(() => {
        if (!params) {
            return;
        }

        const subscriptions = params.map((item, index) => {
            return getSubscriber(item)(
                getChannelName(item),
                item.event,
                (event: IEvent, payload: Message) => {
                    if (item.filterMessages != null && !item.filterMessages(event, payload)) {
                        return;
                    }

                    setLastMessages(list => push(list, index, payload));
                    setLastEventsNames(list => push(list, index, event.name));
                    setLastEventsFiredAt(list => push(list, index, Date.now()));
                    setLastEventFiredAt(Date.now());
                }
            );
        });

        return () => subscriptions.forEach(item => item.unsubscribe());
    }, [params]);

    return {
        lastMessages,
        lastEventsNames,
        lastEventsFiredAt,
        lastEventFiredAt,
    };
}
